export default "/static/images/build_middle_4.png?c22cfa3210a3fe09fcd7ca3160a75641";